// in src/SpotAnalyzer/CreateDashboard.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';

class CreateDashboard extends Component {

    handleClick = () => {
        const {record} = this.props;
        const reportId = '6560ff28-e3ed-416b-9011-b2bcf4736749';
        const firstWord = (record.name && typeof record.name === 'string' ? record.name.trim().split(" ")[0] : '');
        const connectorName = firstWord + ' ' + new Date().getFullYear();
        const reportName = 'RTV Dashboard - ' + connectorName;

        const totalsNr = '1. MBS - SpotAnalyzer GoogleDataStudio connector - Totals - '
        const totals = 'ds711';
        const totalsImplementationId = 'AKfycbyaNEnfxY2KHb5zVLh8_561fgFE93g9vjL6VxmAqN09O5VxmFTodCNoD8tEcv2BAbwNMw';
        const totalsUrl = `&ds.${totals}.datasourceName=${totalsNr} ${connectorName}&ds.${totals}.connector=community&ds.${totals}.connectorId=${totalsImplementationId}&ds.${totals}.uuid=${record.originId}`;

        const resultsNr = '2. MBS - SpotAnalyzer GoogleDataStudio connector - '
        const results = 'ds710';
        const resultsImplementationId = 'AKfycbzpaB_ETueS8PMI0Yj5EOr5oU3wDtEuWRAmRJh96JgjWQop5MqovrmTNfR1JyLEuC5h';
        const resultsUrl = `&ds.${results}.datasourceName=${resultsNr} ${connectorName}&ds.${results}.connector=community&ds.${results}.connectorId=${resultsImplementationId}&ds.${results}.uuid=${record.originId}`;

        const spotsNr = '3. MBS - SpotAnalyzer GoogleDataStudio connector - Spotlijst - '
        const spots = 'ds869';
        const spotsImplementationId = 'AKfycbxAuBcjG3IV01hMRbbNYnByQh6x-o9JxIhUtGaWafSMQHnYxIueiw0BbsHVOoTE_NcrAA';
        const spotsUrl = `&ds.${spots}.datasourceName=${spotsNr} ${connectorName}&ds.${spots}.connector=community&ds.${spots}.connectorId=${spotsImplementationId}&ds.${spots}.uuid=${record.originId}`;

        window.open(`https://lookerstudio.google.com/reporting/create?c.reportId=${reportId}&r.reportName=${reportName}${totalsUrl}${resultsUrl}${spotsUrl}`, '_blank');
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <FileCopyIcon /> &nbsp; New dashboard
        </Button>;
    }
}

CreateDashboard.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(CreateDashboard);